var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.column.render)?_c('Cell',{attrs:{"row":_vm.row,"column":_vm.column,"index":_vm.cindex,"render":_vm.column.render}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }